import React from 'react';
import ContactsSearch from "./search";
import {Link} from "react-router-dom";
import {useLocation} from "react-router";
import {SideList} from "../../components/SideList";
import {ClientCompanyContact, ContactsQueryDocument, useContactsMutationMutation} from "../../generated/graphql";
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";


export const Contacts = ()=>{
  //const recordModuleHistory = useRecordModuleHistory();
  const location = useLocation();

  /*useEffect(()=> {
      recordModuleHistory('contacts',location);
  },[recordModuleHistory,location]);*/

  const columns:FieldTableColumnProps<ClientCompanyContact>[] = [
    {
      accessor:'name',
      header: 'Name',
      dataType:'link',
      options: {
        getLink:({field,row})=>{
          return ({
          pathname: '/contacts/' + row.id,
          search: (location.search ? location.search : '')
          });
        }
      }
    },
    {
      accessor:'clientCompany.sales_company',
      header:'Sales Company',
      dataType:'default'
    },
    {
      accessor:'clientCompany.accounts_company',
      header:'Accounts Company',
      dataType:'default'
    },
    {
      accessor:'phone',
      header:'Phone',
      dataType:'default',
      width:'narrow'
    },
    {
      accessor:'email',
      header:'Email',
      dataType:'default',
      width:'narrow'
    }
  ];
  const searchForm = (args) => {
    return <ContactsSearch {...args} />;
  };
  const deleteMutation = useContactsMutationMutation();
  return <SideList
      searchForm={searchForm}
      label="Contacts"
      className="contacts"
      permission="contacts"
      deleteMutation={deleteMutation}
      simpleDelete={true}
      getResults={(e)=>e.clientCompanyContacts.data}
      query={ContactsQueryDocument}
      columns={columns}
      baseUrl="/contacts/"
  />;


  /*
  return <SideEditor
  editorForm={editorForm}
  searchForm={searchForm}
  label="Contacts "
  permission="contacts"
  className=""
  deleteMutation={contactsMutationNew}
  getResults={(e)=>e.clientCompanyContacts.data}
  query={contactsQuery}
  columns={columns}
  baseUrl="/contacts"
/>*/
}
